export function resolveImageUrl(
  input?: string | null,
  opts?: {
    siteOrigin?: string | null
    assetBaseUrl?: string | null
  }
) {
  const value = String(input || '').trim()
  const siteOrigin = String(opts?.siteOrigin || '').replace(/\/$/, '')
  const assetBaseUrl = String(opts?.assetBaseUrl || '').replace(/\/$/, '')

  if (!value) return '/images/placeholder-course.png'
  if (/^https?:\/\//i.test(value)) return value

  if (value.startsWith('wkseller/')) {
    return siteOrigin ? `${siteOrigin}/image/${value}` : `/image/${value}`
  }

  if (value.startsWith('users/')) {
    if (assetBaseUrl) {
      const base = assetBaseUrl.endsWith('/images')
        ? assetBaseUrl
        : `${assetBaseUrl}/images`

      return `${base}/${value}`
    }

    return `/images/${value}`
  }

  if (value.startsWith('/')) return value

  return `/images/${value}`
}